export const ActionTypes = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  CURRENT_USER_CREDENTIALS_CLEAR: 'CURRENT_USER_CREDENTIALS_CLEAR',
  APPLICATION_LAST_CONNECTION: 'APPLICATION_LAST_CONNECTION',
  DOCUMENTS_ID_CLEAR: 'DOCUMENTS_ID_CLEAR'
};

export const setCurrentUser = user => ({
  type: ActionTypes.SET_CURRENT_USER,
  payload: user
});

export const setLastConnection = lastConnection => ({
  type: ActionTypes.APPLICATION_LAST_CONNECTION,
  payload: lastConnection
});

export const documentIdClear = documentsId => ({
  type: ActionTypes.DOCUMENTS_ID_CLEAR,
  payload: documentsId
});

export const currentUserCredentialsClear = () => ({type: ActionTypes.CURRENT_USER_CREDENTIALS_CLEAR});

export default {
  setCurrentUser,
  currentUserCredentialsClear,
  setLastConnection,
  documentIdClear
};
